// export interface WebGLRenderer {
//   new(): WebGLRenderer
// } 
export function WebGLRenderer(vswebCanvas) {
	var canvas = vswebCanvas

  var vsYUV2RGB = "attribute vec4 position;\
                attribute vec2 texCoord;\
                varying highp vec2 varyingTexCoord;\
                void main(void) {\
                  gl_Position = position;\
                  varyingTexCoord = texCoord;\
                }"

  var fsYUV2RGB = "precision highp float;\
                varying highp vec2 varyingTexCoord;\
                uniform sampler2D yTexSampler;\
                uniform sampler2D uTexSampler;\
                uniform sampler2D vTexSampler;\
                const mat4 yuv2rgb = mat4(1.1643828125, 0, 1.59602734375, -.87078515625,\
                                          1.1643828125, -.39176171875, -.81296875, .52959375,\
                                          1.1643828125, 2.017234375, 0, -1.081390625,\
                                          0, 0, 0, 1);\
                void main(void) {\
                  gl_FragColor = vec4(texture2D(yTexSampler, varyingTexCoord).x,\
                                      texture2D(uTexSampler, varyingTexCoord).x,\
                                      texture2D(vTexSampler, varyingTexCoord).x, 1)\
                                      * yuv2rgb;\
                }"

  var vsRect = "attribute vec4 pos;\
              void main(void) {\
                gl_Position = pos;\
              }"

  var fsRect = "void main(void) {\
                gl_FragColor = vec4(1, 0, 0, 1);\
              }"

  var self = this
  var gl_ = null
  var programYUV2RGB_ = null
  var programRect_ = null
  var texCoordBuffer_ = null
  var yTex_ = null
  var uTex_ = null
  var vTex_ = null
  var width_ = 0
  var height_ = 0
  var yuvData_ = null
  var quadBuffer_ = null
  var rectBuffer_ = null

  function _createProgram(vsSrc, fsSrc) {
    // compile, link and use the shader programs
    var vShader = gl_.createShader(gl_.VERTEX_SHADER)
    gl_.shaderSource(vShader, vsSrc)
    gl_.compileShader(vShader)
    if (!gl_.getShaderParameter(vShader, gl_.COMPILE_STATUS)) {
      throw new Error('vertex shader failed to compile')
    }

    var fShader = gl_.createShader(gl_.FRAGMENT_SHADER)
    gl_.shaderSource(fShader, fsSrc)
    gl_.compileShader(fShader)

    if (!gl_.getShaderParameter(fShader, gl_.COMPILE_STATUS)) {
      throw new Error('fragment shader failed to compile')
    }

    var program = gl_.createProgram()
    gl_.attachShader(program, vShader)
    gl_.attachShader(program, fShader)
    gl_.linkProgram(program)
    if (!gl_.getProgramParameter(program, gl_.LINK_STATUS)) {
      throw new Error('Unable to initialize the shader program')
    }
    return program
  }

  function _initQuadVertexBuffers() {
    // YUV to RGB
    // -----------------
    // | -1,1 (1)      | 1,1 (0)
    // |               |
    // |               | 
    // |               |
    // |               | 
    // |               |
    // | -1,-1 (3)     | 1,-1 (2)
    // -----------------
    quadBuffer_ = gl_.createBuffer()
    gl_.bindBuffer(gl_.ARRAY_BUFFER, quadBuffer_)
    gl_.bufferData(gl_.ARRAY_BUFFER, new Float32Array([1, 1, -1, 1, 1, -1, -1, -1]), gl_.STATIC_DRAW)

    // var vertexAttribRef = gl_.getAttribLocation(programYUV2RGB_, 'position')
    // gl_.enableVertexAttribArray(vertexAttribRef)
    // gl_.vertexAttribPointer(vertexAttribRef, 2, gl_.FLOAT, false, 0, 0)

    texCoordBuffer_ = gl_.createBuffer()
    gl_.bindBuffer(gl_.ARRAY_BUFFER, texCoordBuffer_)
    gl_.bufferData(gl_.ARRAY_BUFFER, new Float32Array([1, 0, 0, 0, 1, 1, 0, 1]), gl_.STATIC_DRAW)

    // var texCoordAttribRef = gl_.getAttribLocation(programYUV2RGB_, 'texCoord')
    // gl_.enableVertexAttribArray(texCoordAttribRef)
    // gl_.vertexAttribPointer(texCoordAttribRef, 2, gl_.FLOAT, false, 0, 0)
  }

  function _initRectBuffer() {
    rectBuffer_ = gl_.createBuffer()
  }

  function _createTexture() {
    var tex = gl_.createTexture()
    gl_.bindTexture(gl_.TEXTURE_2D, tex)
    gl_.texParameteri(gl_.TEXTURE_2D, gl_.TEXTURE_MAG_FILTER, gl_.LINEAR);
    gl_.texParameteri(gl_.TEXTURE_2D, gl_.TEXTURE_MIN_FILTER, gl_.LINEAR);
    gl_.texParameteri(gl_.TEXTURE_2D, gl_.TEXTURE_WRAP_S, gl_.CLAMP_TO_EDGE);
    gl_.texParameteri(gl_.TEXTURE_2D, gl_.TEXTURE_WRAP_T, gl_.CLAMP_TO_EDGE);
    gl_.bindTexture(gl_.TEXTURE_2D, null);
    return tex
  }

  function _initYUVTextures() {
    gl_.useProgram(programYUV2RGB_)
    var ySamplerRef = gl_.getUniformLocation(programYUV2RGB_, 'yTexSampler')
    gl_.uniform1i(ySamplerRef, 0)
    var uSamplerRef = gl_.getUniformLocation(programYUV2RGB_, 'uTexSampler')
    gl_.uniform1i(uSamplerRef, 1)
    var vSamplerRef = gl_.getUniformLocation(programYUV2RGB_, 'vTexSampler')
    gl_.uniform1i(vSamplerRef, 2)
    yTex_ = _createTexture()
    uTex_ = _createTexture()
    vTex_ = _createTexture()
  }

  self.init = function (glContext) {
    gl_ = glContext
    programYUV2RGB_ = _createProgram(vsYUV2RGB, fsYUV2RGB)
    programRect_ = _createProgram(vsRect, fsRect)
    _initQuadVertexBuffers()
    _initYUVTextures()
    _initRectBuffer()
  }

  self.draw = function (w, h, yuvArrayBuffer) {
    if (w && h && yuvArrayBuffer) {
      width_ = w
      height_ = h
      yuvData_ = new Uint8Array(yuvArrayBuffer)
    }

    gl_.useProgram(programYUV2RGB_)

    gl_.bindBuffer(gl_.ARRAY_BUFFER, quadBuffer_)
    var vertexAttribRef = gl_.getAttribLocation(programYUV2RGB_, 'position')
    gl_.enableVertexAttribArray(vertexAttribRef)
    gl_.vertexAttribPointer(vertexAttribRef, 2, gl_.FLOAT, false, 0, 0)

    gl_.bindBuffer(gl_.ARRAY_BUFFER, texCoordBuffer_)
    var texCoordAttribRef = gl_.getAttribLocation(programYUV2RGB_, 'texCoord')
    gl_.enableVertexAttribArray(texCoordAttribRef)
    gl_.vertexAttribPointer(texCoordAttribRef, 2, gl_.FLOAT, false, 0, 0)

    var frameLength = width_ * height_
    var quarterLength = frameLength / 4
    var yData = yuvData_.subarray(0, frameLength)
    gl_.activeTexture(gl_.TEXTURE0)
    gl_.bindTexture(gl_.TEXTURE_2D, yTex_)
    gl_.texImage2D(gl_.TEXTURE_2D, 0, gl_.LUMINANCE, width_, height_, 0, gl_.LUMINANCE, gl_.UNSIGNED_BYTE, yData)

    var uData = yuvData_.subarray(frameLength, frameLength + quarterLength)
    gl_.activeTexture(gl_.TEXTURE1)
    gl_.bindTexture(gl_.TEXTURE_2D, uTex_)
    gl_.texImage2D(gl_.TEXTURE_2D, 0, gl_.LUMINANCE, width_ / 2, height_ / 2, 0, gl_.LUMINANCE, gl_.UNSIGNED_BYTE, uData)

    var vData = yuvData_.subarray(frameLength + quarterLength, frameLength + quarterLength + quarterLength)
    gl_.activeTexture(gl_.TEXTURE2)
    gl_.bindTexture(gl_.TEXTURE_2D, vTex_)
    gl_.texImage2D(gl_.TEXTURE_2D, 0, gl_.LUMINANCE, width_ / 2, height_ / 2, 0, gl_.LUMINANCE, gl_.UNSIGNED_BYTE, vData)

    gl_.drawArrays(gl_.TRIANGLE_STRIP, 0, 4)
		
		if (canvas.modeTransition === true) {
			canvas.canvas2D.style.display = 'none'
			canvas.canvasGL.style.display = 'block'
			canvas.modeTransition = false
		}
  }

  // in case of low resolution: add more parameters to represent native video dimension 
  self.viewport = function (clientW, clientH, imageWidth, imageHeight, videoWidth, videoHeight) {
    gl_.bindBuffer(gl_.ARRAY_BUFFER, texCoordBuffer_)
    gl_.bufferData(gl_.ARRAY_BUFFER, new Float32Array([imageWidth / videoWidth, 0, 0, 0, imageWidth / videoWidth, imageHeight / videoHeight, 0, imageHeight / videoHeight]), gl_.STATIC_DRAW)
    gl_.viewport(0, 0, clientW, clientH)
  }

  self.drawRect = function (clientW, clientH, x, y, w, h) {
    // redraw the last YUV buffer
    self.draw()

    gl_.useProgram(programRect_)

    gl_.bindBuffer(gl_.ARRAY_BUFFER, rectBuffer_)

    var normX = (2 * x - clientW) / clientW
    var normY = (clientH - 2 * y) / clientH

    var normW = 2 * w / clientW
    var normH = 2 * h / clientH

    var rectData = new Float32Array([normX, normY,
      normX + normW, normY,
      normX + normW, normY - normH,
      normX, normY - normH])

    gl_.bufferData(gl_.ARRAY_BUFFER, rectData, gl_.DYNAMIC_DRAW)

    var vertexAttribRef = gl_.getAttribLocation(programRect_, 'pos')
    gl_.enableVertexAttribArray(vertexAttribRef)
    gl_.vertexAttribPointer(vertexAttribRef, 2, gl_.FLOAT, false, 0, 0)

    gl_.drawArrays(gl_.LINE_LOOP, 0, 4)

  }


};



// WEBPACK FOOTER //
// ./base/vsweb-renderer.ts